import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, Menu, X, Facebook, Car } from "lucide-react";
import { business, navLinks } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50">
      {/* Top contact bar */}
      <div className="bg-[#242424] text-gray-300 text-sm hidden md:block">
        <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <span className="text-[#84bd00] font-semibold tracking-wide">
              CONTACT DENTCRAFT NSW
            </span>
            <a href={`tel:${business.phoneRaw}`} className="flex items-center gap-2 hover:text-white transition-colors">
              <Phone size={14} className="text-[#84bd00]" /> Call Sam on {business.phone}
            </a>
            <a href={`mailto:${business.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
              <Mail size={14} className="text-[#84bd00]" /> {business.email}
            </a>
          </div>
          <a href={business.facebook} target="_blank" rel="noreferrer" className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#84bd00] transition-colors">
            <Facebook size={14} />
          </a>
        </div>
      </div>

      {/* Main nav */}
      <div className={`transition-all duration-300 ${scrolled ? "bg-[#2f2f2f]/95 backdrop-blur shadow-lg" : "bg-[#333333]"}`}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-11 h-11 rounded-xl bg-[#84bd00] flex items-center justify-center group-hover:scale-105 transition-transform">
              <Car size={24} className="text-white" />
            </div>
            <div className="leading-tight">
              <div className="text-white font-display font-extrabold text-xl tracking-tight">
                DENTCRAFT <span className="text-[#84bd00]">NSW</span>
              </div>
              <div className="text-gray-400 text-[11px] tracking-widest uppercase">Paintless Dent Removal</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className={`nav-link text-sm font-semibold tracking-wide transition-colors ${
                  location.pathname === l.path ? "active text-[#84bd00]" : "text-gray-200 hover:text-white"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <a
              href={`tel:${business.phoneRaw}`}
              className="ml-2 inline-flex items-center gap-2 bg-[#84bd00] hover:bg-[#75a800] text-white font-semibold text-sm px-5 py-2.5 rounded-lg transition-colors"
            >
              <Phone size={16} /> {business.phone}
            </a>
          </nav>

          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden bg-[#2b2b2b] border-t border-white/10 animate-fade-up">
            <nav className="flex flex-col px-6 py-4">
              {navLinks.map((l) => (
                <Link
                  key={l.path}
                  to={l.path}
                  className={`py-3 text-sm font-semibold border-b border-white/5 ${
                    location.pathname === l.path ? "text-[#84bd00]" : "text-gray-200"
                  }`}
                >
                  {l.label}
                </Link>
              ))}
              <a href={`tel:${business.phoneRaw}`} className="mt-4 inline-flex items-center justify-center gap-2 bg-[#84bd00] text-white font-semibold px-5 py-3 rounded-lg">
                <Phone size={16} /> Call {business.phone}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
